import { useEntityUrl } from 'framework/routing';
import { ResourceId } from 'framework/crud';

export const STAFFING_PROJECT_PATH = '/staffing-project';

export const getStaffingProjectUrl = (projectId: string) => `${STAFFING_PROJECT_PATH}/${projectId}`;

export const STAFFING_PROJECT_TAB = {
  STAFFING: 'staffing',
  TRENDS: 'trends',
  TIMELINE: 'timeline',
} as const;

export const getStaffingProjectTabUrl = (projectId: string, tab: string) =>
  `${getStaffingProjectUrl(projectId)}/${tab}`;

export const STAFFING_PROJECT_ROUTES = {
  PROJECT: ':projectId',
  TRENDS: 'trends',
  TIMELINE: 'timeline/:timelineEntryId?',
} as const;

export const useStaffingProjectUrl = () => {
  const { getSingleEntityUrl } = useEntityUrl({
    baseLink: STAFFING_PROJECT_PATH,
    idSource: 'projectId',
  });

  return {
    getStaffingProjectUrl: (projectId?: ResourceId) => getSingleEntityUrl(projectId),
    getStaffingProjectTabUrl: (projectId?: ResourceId, tab?: string) => `${getSingleEntityUrl(projectId)}/${tab ?? ''}`,
  };
};
